export default "__VITE_ASSET__Btw$twC8__"